"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_hook_form_1 = require("react-hook-form");
const FormContext_1 = require("../../contexts/FormContext");
const withJourney_1 = __importDefault(require("../../hocs/withJourney"));
const helpers_1 = require("../../lib/helpers");
const useCurrentRef_1 = require("../../hooks/useCurrentRef");
function Form(props) {
    const { children, onChange, value, onError } = props;
    const [submitting, setSubmitting] = react_1.useState(false);
    const [errors, setErrors] = react_1.useState([]);
    const { register, handleSubmit, control: { fieldsRef } } = react_hook_form_1.useForm(); // initialize the hook
    const formRef = react_1.useRef(null);
    const onChangeRef = react_1.useRef({ onChange, value: props.value });
    onChangeRef.current = { onChange, value: props.value };
    const setFormData = react_1.useCallback((newFormAction) => {
        if (typeof newFormAction === 'function') {
            newFormAction = newFormAction(onChangeRef.current.value);
        }
        if (newFormAction instanceof Promise) {
            newFormAction.then((newFormData) => {
                onChangeRef.current.onChange(newFormData);
            }).catch(console.error);
        }
        else {
            onChangeRef.current.onChange(newFormAction);
        }
    }, []);
    const contextValue = react_1.useMemo(() => ({
        formData: value,
        inForm: true,
        submitting,
        setSubmitting,
        errors,
        setErrors,
        setFormData,
        registerInput: register,
        fieldsRef,
        formRef,
    }), [value, submitting, errors, setFormData, register, fieldsRef]);
    const onSubmit = handleSubmit(() => { });
    const onErrorRef = useCurrentRef_1.useCurrentRef(onError);
    react_1.useEffect(() => {
        var _a;
        if (errors.length > 0) {
            (_a = onErrorRef.current) === null || _a === void 0 ? void 0 : _a.call(onErrorRef, errors);
        }
    }, [errors, onErrorRef]);
    return (react_1.default.createElement("form", Object.assign({}, helpers_1.without(helpers_1.usePrimitiveProps(props), ['value', 'onChange']), { onSubmit: onSubmit, ref: formRef }),
        react_1.default.createElement(FormContext_1.FormContext.Provider, { value: contextValue }, children)));
}
exports.default = withJourney_1.default('j-form', Form);
